import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as checkoutActionCreators from '../actions/actionCreators/checkout';
import Checkout from '../components/Checkout/Checkout';

function mapStateToProps(state) {

    return {
        locale: state.app.locale,
        penName: state.configurator.penName || state.staticPen.pen.name || '',
        penId: state.configurator.penId || state.staticPen.pen.id || null,
        minOrderAmount: state.configurator.config === undefined ? state.staticPen.pen.minimum_order_amount.number : state.configurator.config.minOrderAmount,
        isStatic: state.configurator.config === undefined,
        config: state.configurator.config || {},
        customImages: state.configurator.customImages || [],
        customTexts: state.configurator.customTexts || [],
        penShots: state.configurator.penShots || [],
        mine: state.configurator.mine,
        texts: state.app.texts,
        ...state.checkout,
    };
}

function mapDispatchToProps(dispatch) {
    return { ...bindActionCreators(checkoutActionCreators, dispatch) };
}

const ConfiguratorContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Checkout);

export default ConfiguratorContainer;
